/**
 * Framer Motion variants for PROTEGE QV Lecture+
 * Uses opacity + transform only for performance.
 * All variants respect prefers-reduced-motion when useReducedMotion() is true.
 */

export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (reduce = false) =>
    reduce
      ? { opacity: 1 }
      : {
          opacity: 1,
          y: 0,
          transition: { duration: 0.5, ease: [0, 0, 0.2, 1] },
        },
};

export const fadeLeft = {
  hidden: { opacity: 0, x: -20 },
  visible: (reduce = false) =>
    reduce
      ? { opacity: 1 }
      : {
          opacity: 1,
          x: 0,
          transition: { duration: 0.4, ease: 'easeOut' },
        },
};

export const fadeRight = {
  hidden: { opacity: 0, x: 20 },
  visible: (reduce = false) =>
    reduce
      ? { opacity: 1 }
      : {
          opacity: 1,
          x: 0,
          transition: { duration: 0.4, ease: 'easeOut' },
        },
};

export const staggerContainer = (reduce = false) => ({
  hidden: {},
  visible: reduce
    ? {}
    : {
        transition: {
          staggerChildren: 0.08,
          delayChildren: 0.1,
        },
      },
});

export const cardHover = (reduce = false) =>
  reduce ? {} : { y: -4, boxShadow: '0 8px 24px rgba(46, 139, 87, 0.15)' };

export const successBounce = {
  initial: { scale: 0.8, opacity: 0 },
  animate: (reduce = false) =>
    reduce
      ? { scale: 1, opacity: 1 }
      : {
          scale: [0.8, 1.05, 1],
          opacity: [0, 1, 1],
          transition: { duration: 0.4, times: [0, 0.7, 1] },
        },
};

export const slideUp = {
  hidden: { opacity: 0, y: 40 },
  visible: (reduce = false) =>
    reduce
      ? { opacity: 1 }
      : {
          opacity: 1,
          y: 0,
          transition: { duration: 0.3, ease: 'easeOut' },
        },
};

/** For use with motion components - pass reduce from useReducedMotion() */
export const getFadeUpVariants = (reduce) => ({
  hidden: fadeUp.hidden,
  visible: fadeUp.visible(reduce),
});

export const getFadeLeftVariants = (reduce) => ({
  hidden: fadeLeft.hidden,
  visible: fadeLeft.visible(reduce),
});

export const getFadeRightVariants = (reduce) => ({
  hidden: fadeRight.hidden,
  visible: fadeRight.visible(reduce),
});

export const getStaggerContainer = (reduce) => staggerContainer(reduce);
